
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91id_93S9odig5r3SU_kfEOpMu5Q8PxnrWtcqgwChAM4LT0pSIMeta } from "/app/app/pages/group/[id].vue?macro=true";
export default [
  {
    name: "auth-callback",
    path: "/auth/callback",
    component: () => import("/app/app/pages/auth/callback.vue")
  },
  {
    name: "bots-approvals",
    path: "/bots/approvals",
    component: () => import("/app/app/pages/bots/approvals.vue")
  },
  {
    name: "group-id",
    path: "/group/:id()",
    meta: _91id_93S9odig5r3SU_kfEOpMu5Q8PxnrWtcqgwChAM4LT0pSIMeta || {},
    component: () => import("/app/app/pages/group/[id].vue")
  },
  {
    name: "m-friends-id",
    path: "/m-friends/:id()",
    component: () => import("/app/app/pages/m-friends/[id].vue")
  },
  {
    name: "m-groups-id",
    path: "/m-groups/:id()",
    component: () => import("/app/app/pages/m-groups/[id].vue")
  },
  {
    name: "bots",
    path: "/bots",
    component: () => import("/app/app/pages/bots/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/app/app/pages/dashboard.vue")
  },
  {
    name: "debug",
    path: "/debug",
    component: () => import("/app/app/pages/debug.vue")
  },
  {
    name: "groups",
    path: "/groups",
    component: () => import("/app/app/pages/groups.vue")
  },
  {
    name: "sentry-test",
    path: "/sentry-test",
    component: () => import("/app/app/pages/sentry-test.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/app/app/pages/settings.vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    component: () => import("/app/app/pages/subscription.vue")
  },
  {
    name: "subscription-success",
    path: "/subscription-success",
    component: () => import("/app/app/pages/subscription-success.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  }
]